module.exports = __webpack_public_path__ + "img/SOLUSDC.a6ed68c5.png";